import { render, staticRenderFns } from "./EmailAuthTutorial.vue?vue&type=template&id=3c4dccc6&scoped=true"
import script from "./EmailAuthTutorial.vue?vue&type=script&lang=js"
export * from "./EmailAuthTutorial.vue?vue&type=script&lang=js"
import style0 from "./EmailAuthTutorial.vue?vue&type=style&index=0&id=3c4dccc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4dccc6",
  null
  
)

export default component.exports